import { apiGet, apiPost } from "./client";
import type { ApprovalCategory } from "./overrides";

export type ChangeRequest = {
  id: string;
  kind: "change";
  action: "create" | "update";
  permissionKey: string;
  category: ApprovalCategory;
  targetType: string;
  targetId: string | null;
  status: string;
  summary: string | null;
  diffs: Array<{ field: string; before: string | null; after: string | null }>;
  requesterUserId: string;
  approverUserId: string | null;
  createdAt: string;
  decidedAt: string | null;
};

export function listChangeRequests(companyRef: string, status = "pending") {
  return apiGet<{
    requests: ChangeRequest[];
    counts: {
      pending: number;
      operational: number;
      destructive: number;
    };
  }>(
    `/c/${companyRef}/changes/requests?status=${encodeURIComponent(status)}`,
  );
}

export function approveChangeRequest(
  companyRef: string,
  requestId: string,
  body?: { decisionNote?: string },
) {
  return apiPost<{
    request: { id: string; status: string; category: ApprovalCategory };
  }>(`/c/${companyRef}/changes/requests/${requestId}/approve`, body ?? {});
}

export function denyChangeRequest(
  companyRef: string,
  requestId: string,
  body?: { decisionNote?: string },
) {
  return apiPost<{ request: { id: string; status: string } }>(
    `/c/${companyRef}/changes/requests/${requestId}/deny`,
    body ?? {},
  );
}

export function mintChangeOtp(companyRef: string, requestId: string) {
  return apiPost<{
    otp: {
      code: string;
      expiresAt: string;
      permissionKey: string;
      requestId: string;
      requestKind: "change";
    };
  }>(`/c/${companyRef}/changes/requests/${requestId}/otp`);
}
